export default __webpack_public_path__ + "static/media/blog-img230.f3288f49.jpg";